<template>
  <div class="tw-relative tw-w-full tw-h-full tw-group" :class="{'tw-cursor-pointer': $slots.length}" v-on="$listeners">
    <!-- Overlay Shadow -->
    <div class="tw-absolute tw-transition tw-w-full tw-h-full tw-opacity-60" :class="{
      'tw-bg-infinity-highlight': active && !activeTransparent,
      'group-hover:tw-bg-infinity-highlight': hasSlot && !activeTransparent,
      'tw-bg-grey-900 tw-bg-opacity-25': activeTransparent
    }" />
    <!-- Overlay Item -->
    <div :is="to ? 'router-link' : 'div'" :to="to"
         class="tw-absolute tw-transition tw-inset-0 tw-flex tw-items-center tw-justify-center touch:tw-opacity-100 group-hover:tw-opacity-100"
         :class="{'tw-opacity-100': active || activeTransparent, 'tw-opacity-0': !activeTransparent}">
      <slot name="center"></slot>
    </div>
    <!-- Image -->
    <img class="tw-block tw-w-full tw-h-auto tw-border-none tw-bg-infinity-card-background" :src="src" :width="imageSize" :height="imageSize" alt="">
  </div>
</template>
<script>
export default {
  props: {
    to: {
      type: Object
    },
    src: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    activeTransparent: {
      type: Boolean,
      default: false
    },
    imageSize: {
      type: [String, Number],
      default: 300
    }
  },
  computed: {
    hasSlot() {
      return !!Object.keys(this.$slots).length
    }
  }
}
</script>
